export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTACT = {
  phoneDisplay: "06 62 33 81 18",
  phoneHref: "tel:+33662338118",
  email: "louislarsson@gmail.com",
  emailHref: "mailto:louislarsson@gmail.com",
  zone: "Les Mesnuls (78) et communes dans un rayon de 20 km",
  hours: "Du lundi au samedi, de 8h à 20h",
};

export const CATEGORIES = [
  "Peinture Intérieure",
  "Rénovation Complète",
  "Ravalement Extérieur",
  "Boiseries & Laques",
  "Sols Béton",
];

export const HERO_IMAGE = "/hero-louis.jpg";

export function photoSrc(photo) {
  if (!photo?.src) return "";
  if (photo.src.startsWith("http")) return photo.src;
  return `${process.env.REACT_APP_BACKEND_URL}${photo.src}`;
}
